import lozad from 'lozad'
import { header } from '../index/scripts/header';
$(document).ready(function () {
	header.init();
	clickScrollToDiv();
})
/*==================== Workflow  ====================*/
function clickScrollToDiv () {
	var enableDisableElements = $('.item-step-process')
	for (var i = 0, length = enableDisableElements.length; i < length; i++) {
		new Waypoint({
			element: enableDisableElements[i],
			handler: function (direction) {
				const _index = $(this.element)
					.attr('id')
				const index = _index.slice(-1)
				$(`.item-process[data-step="${index}"]`).addClass('active').siblings().removeClass('active')
			},
			offset: '30%',
		})
	}
	$('.item-process').on('click', function () {
		Waypoint.disableAll()
		const step = $(this).data('step');
		$(this).addClass('active').siblings().removeClass('active');
		$("html, body").animate(
			{
				scrollTop: $(`#step-${step}`).offset().top - $('.header-2').outerHeight() - $('.wrap-workflow-process').outerHeight(),
			},
			800
		);
		setTimeout(() => {
			Waypoint.enableAll()
		},1000)
	})
}
/*==================== Lazyload JS ====================*/
const observer = lozad() // lazy loads elements with default selector as '.lozad'
observer.observe()
